(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = this.querySelectorAll('[data-control]');

      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
      this.viewportWidth = window.innerWidth;
      [
        'shopify:section:load',
        'load',
        'resize'
      ].forEach((event) => {
        window.addEventListener(event, () => {
          if (event == 'resize' && window.innerWidth == this.viewportWidth) return;
          this.viewportWidth = window.innerWidth;
          this.calcHeight();
        });
      });
    }

    connectedCallback() {
      this.slider = new Splide(this, {
        type: Number(this.dataset.slidesCount) > 1 ? 'loop' : 'slide',
        rewind: false,
        drag: Number(this.dataset.slidesCount) > 1,
        pagination: false,
        waitForTransition: true,
        arrows: false,
        speed: 600,
        easing: 'ease-in-out',
        autoplay: JSON.parse(this.dataset.autoplay),
        interval: Number(this.dataset.autoplayInterval),
        start: 0
      }).mount();
      this.addAnimationHanler();
      this.updateImageClasses();
    }

    addAnimationHanler() {
      this.querySelectorAll('[data-fade-in]')?.forEach((element) => {
        element.addEventListener('animationend', (event) => {
          this.addFadeAnimations();
        })
      })
    }

    updateImageClasses() {
      this.querySelectorAll('.lazyloading')?.forEach(lazyloadImage => {
        lazyloadImage.classList.remove('lazyloading')
        lazyloadImage.classList.add('lazyloaded')
      })
    }

    addFadeAnimations() {
      this.animatedElements = this.querySelectorAll('[data-fade-in]');
      this.animatedElements.forEach((element) => {
        element.classList.add('fade-in');
      })
    }

    onControlClick(event) {
      event.preventDefault();

      if (this.slider === {}) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.slider.go(action);
    }

    calcHeight() {
      const announcementBar = document.querySelector('#shopify-section-announcement-bar:not(#shopify-section-header + #shopify-section-announcement-bar)');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

      const headerOffset =
        announcementBarHeight +
        document.querySelector('#shopify-section-header').offsetHeight;

      this.querySelectorAll('.hero__block').forEach((element) => {
        const heroHeight = element.dataset.heroHeight;
        element.style.height =
          window.innerWidth > 989
            ? 'auto'
            : `calc(${heroHeight}vmax - ${headerOffset}px)`;
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();

/* ------------------------------------------------------------------
 * VIN lookup for the hero "Search by VIN or part number" box.
 * A 17-character VIN is decoded with the free NHTSA vPIC service and
 * the shopper is shown the matching "Shop by truck" collections.
 * Anything else (part numbers, keywords) goes to normal store search.
 * ------------------------------------------------------------------ */
(() => {
  if (window.__afhVinSearch) return;
  window.__afhVinSearch = true;

  const VIN_PATTERN = /^[A-HJ-NPR-Z0-9]{17}$/;
  const DECODE_URL = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/';
  const FITMENT_URL = '/pages/contact-us';
  const ALL_URL = '/collections/all';

  const COLLECTIONS = {
    ram67: { url: '/collections/ram-6-7l-cummins', label: 'Shop Ram 6.7L Cummins parts' },
    ford67: { url: '/collections/ford-6-7l-power-stroke', label: 'Shop Ford 6.7L Power Stroke parts' },
    fordClassic: { url: '/collections/ford-classic-power-stroke', label: 'Shop Ford 7.3L, 6.0L & 6.4L Power Stroke parts' },
    hdCummins: { url: '/collections/heavy-duty-cummins', label: 'Shop heavy-duty Cummins parts' },
    hdCumminsMaybe: { url: '/collections/heavy-duty-cummins', label: 'Shop heavy-duty Cummins parts (ISX / X15 engines)' },
    fordIgnition: { url: '/collections/ford-v6-v8-ignition', label: 'Shop Ford V6 & V8 ignition parts' },
    fordTpms: { url: '/collections/ford-tpms-sensors', label: 'Shop Ford TPMS sensors' }
  };

  const HEAVY_TRUCK_MAKES = ['FREIGHTLINER', 'PETERBILT', 'KENWORTH', 'INTERNATIONAL', 'NAVISTAR', 'WESTERN STAR', 'STERLING'];

  const style = document.createElement('style');
  style.textContent = `
    .hero__vin-result { width: min(100%, 640px); margin: -8px 0 20px; padding: 16px 18px; border-radius: 6px; background: #fff; color: #172033; box-shadow: 0 5px 18px rgba(0,0,0,.18); font-size: 15px; line-height: 1.45; text-align: left; }
    .hero__vin-result[hidden] { display: none; }
    .hero__main__wrapper--horizontal-center .hero__vin-result { margin-left: auto; margin-right: auto; }
    .hero__main__wrapper--horizontal-right .hero__vin-result { margin-left: auto; }
    .hero__vin-result__vehicle { margin: 0 0 4px; font-size: 17px; font-weight: 700; color: #0b3a82; }
    .hero__vin-result__text { margin: 0 0 12px; }
    .hero__vin-result__links { display: flex; flex-wrap: wrap; gap: 8px; margin: 0 0 10px; }
    .hero__vin-result__link { display: inline-block; padding: 10px 16px; border-radius: 6px; background: #0b3a82; color: #fff !important; font-weight: 700; text-decoration: none; }
    .hero__vin-result__link:hover { background: #f7941d; color: #0b3a82 !important; }
    .hero__vin-result__link--secondary { background: transparent; color: #0b3a82 !important; border: 2px solid #0b3a82; }
    .hero__vin-result__help { margin: 0; font-size: 14px; }
    .hero__vin-result__help a { color: #0b3a82; font-weight: 700; text-decoration: underline; }
    @media screen and (max-width: 749px) {
      .hero__vin-result__link { width: 100%; text-align: center; }
    }
  `;
  document.head.appendChild(style);

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function getPanel(form) {
    let panel = form.nextElementSibling;
    if (!panel || !panel.classList.contains('hero__vin-result')) {
      panel = el('div', 'hero__vin-result');
      panel.setAttribute('role', 'status');
      panel.setAttribute('aria-live', 'polite');
      form.after(panel);
    }
    panel.hidden = false;
    return panel;
  }

  function pauseSlider(form) {
    try {
      form.closest('hero-slider')?.slider?.Components?.Autoplay?.pause();
    } catch (e) { /* slider not ready, ignore */ }
  }

  function matchCollections(v) {
    const make = (v.Make || '').toUpperCase().trim();
    const fuel = (v.FuelTypePrimary || '').toLowerCase();
    const diesel = fuel.includes('diesel');
    const gas = fuel.includes('gasoline') || fuel.includes('flexible');
    const litres = parseFloat(v.DisplacementL);
    const near = (size) => !isNaN(litres) && Math.abs(litres - size) < 0.15;
    const engineText = `${v.EngineManufacturer || ''} ${v.EngineModel || ''} ${v.OtherEngineInfo || ''}`.toUpperCase();
    const isRam = make === 'RAM' || make === 'DODGE';
    const keys = [];

    if (isRam && diesel && near(6.7)) {
      keys.push('ram67');
    } else if (make === 'FORD' && diesel && near(6.7)) {
      keys.push('ford67');
    } else if (make === 'FORD' && diesel && (near(7.3) || near(6.0) || near(6.4))) {
      keys.push('fordClassic');
    } else if (!isRam && diesel && /CUMMINS|ISX|X15|X-15/.test(engineText)) {
      keys.push('hdCummins');
    } else if (diesel && HEAVY_TRUCK_MAKES.includes(make) && (isNaN(litres) || litres >= 10)) {
      keys.push('hdCumminsMaybe');
    } else if (make === 'FORD' && gas) {
      keys.push('fordIgnition');
    }

    if (make === 'FORD') keys.push('fordTpms');
    return keys;
  }

  function describe(v) {
    const name = [v.ModelYear, v.Make, v.Model].filter(Boolean).join(' ');
    const litres = parseFloat(v.DisplacementL);
    const engine = [!isNaN(litres) ? `${litres.toFixed(1)}L` : '', v.FuelTypePrimary || ''].filter(Boolean).join(' ');
    return engine ? `${name} · ${engine}` : name;
  }

  function helpLine(vin, lead) {
    const p = el('p', 'hero__vin-result__help');
    p.append(document.createTextNode(lead + ' '));
    const a = el('a', null, 'Get a free fitment check');
    a.href = FITMENT_URL;
    p.append(a);
    p.append(document.createTextNode(` — just send us your VIN (${vin}).`));
    return p;
  }

  function render(panel, parts) {
    panel.replaceChildren(...parts.filter(Boolean));
  }

  function linkButton(item, secondary) {
    const a = el('a', 'hero__vin-result__link' + (secondary ? ' hero__vin-result__link--secondary' : ''), item.label);
    a.href = item.url;
    return a;
  }

  async function decode(vin) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const res = await fetch(`${DECODE_URL}${encodeURIComponent(vin)}?format=json`, { signal: controller.signal });
      if (!res.ok) throw new Error('Lookup failed');
      const data = await res.json();
      return data && data.Results && data.Results[0];
    } finally {
      clearTimeout(timer);
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('hero__part-search')) return;

    const input = form.querySelector('input[name="q"]');
    const vin = (input?.value || '').toUpperCase().replace(/[\s-]/g, '');
    if (!VIN_PATTERN.test(vin)) return; // part number or keyword: normal search

    event.preventDefault();
    pauseSlider(form);

    const button = form.querySelector('button[type="submit"]');
    const buttonLabel = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Checking…'; }

    const panel = getPanel(form);
    render(panel, [el('p', 'hero__vin-result__text', 'Looking up your VIN…')]);

    try {
      const v = await decode(vin);

      if (!v || !v.Make) {
        render(panel, [
          el('p', 'hero__vin-result__vehicle', 'We couldn’t find a vehicle for that VIN'),
          el('p', 'hero__vin-result__text', 'Please double-check all 17 characters. VINs never contain the letters I, O or Q.'),
          helpLine(vin, 'Still stuck?')
        ]);
        return;
      }

      const keys = matchCollections(v);
      const vehicle = el('p', 'hero__vin-result__vehicle', describe(v));

      if (keys.length) {
        const links = el('div', 'hero__vin-result__links');
        keys.forEach((key, i) => links.append(linkButton(COLLECTIONS[key], i > 0)));
        render(panel, [
          vehicle,
          el('p', 'hero__vin-result__text', 'Here are the parts we carry for your vehicle:'),
          links,
          helpLine(vin, 'Want us to confirm the exact part?')
        ]);
      } else {
        const links = el('div', 'hero__vin-result__links');
        links.append(linkButton({ url: ALL_URL, label: 'Browse all parts' }, true));
        render(panel, [
          vehicle,
          el('p', 'hero__vin-result__text', 'We don’t have a dedicated parts page for this vehicle yet, but we may still be able to help.'),
          links,
          helpLine(vin, 'Not sure what fits?')
        ]);
      }
    } catch (error) {
      render(panel, [
        el('p', 'hero__vin-result__vehicle', 'VIN lookup is busy right now'),
        el('p', 'hero__vin-result__text', 'Please try again in a moment.'),
        helpLine(vin, 'Or skip the wait:')
      ]);
    } finally {
      if (button) { button.disabled = false; button.textContent = buttonLabel; }
    }
  });
})();
